export const fieldsToCheck = [
    "workload",
    "attention",
    "breakFrequency",
    "averageLengthOfBreaks",
    "longestWorkPeriodOfContinuousWork",
    "breakLengthAfterLongestWorkPeriod",
];

export const parseTime = (time: string | null) => {
    if (!time) return { hours: "", minutes: "" };
    const [h, m] = time.split(":");

    return { hours: h, minutes: m };
};

export   function toTimeString(hours: any, minutes: any) {
    const h = String(Number(hours)).padStart(2, '0');
    const m = String(Number(minutes)).padStart(2, '0');
    return `${h}:${m}:00`;
}

export   const extractTime = (dateTimeString: string | null) => {
    if (!dateTimeString) return "";
    const date = new Date(dateTimeString);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
};
